<mat-card class="list-card flex-col flex" style="overflow: visible">
    <mat-card-header>
        <div mat-card-avatar class="cb-card-avatar-icon mat-mdc-header-card-avatar">
            @if (mappedItem?.stepHouseAndLandComplete) {
                <mat-icon class="cb-primary"> check_circle </mat-icon>
            }
            @if (!mappedItem?.stepHouseAndLandComplete) {
                <mat-icon class="cb-warn"> warning </mat-icon>
            }
        </div>
        <mat-card-title>2. Lot Interests</mat-card-title>
    </mat-card-header>
    <mat-card-content class="start-start flex-col flex cb-margin-bottom-2x">
        @if (mappedItem?.interests?.length > 0) {
            @for (interest of sortedMappedItemInterests; track interest; let last = $last) {
                <div class="flex-col" style="width: 100%">
                    <mat-divider></mat-divider>
                    <div class="start-center flex-row flex" style="padding: 16px 0">
                        @if (
                            interest.isPrimary &&
                            (!interest.lotIsNotAvailable || interest.isQualified)
                        ) {
                            <mat-icon title="Primary Lot Interest" class="cb-accent"
                                >stars
                            </mat-icon>
                        }
                        @if (
                            !interest.isPrimary &&
                            (!interest.lotIsNotAvailable || interest.isQualified)
                        ) {
                            <mat-icon> radio_button_unchecked </mat-icon>
                        }
                        @if (interest.lotIsNotAvailable && !interest.isQualified) {
                            <mat-icon class="cb-warn"> warning </mat-icon>
                        }
                        <div class="flex-row flex" style="margin-left: 12px; width: max-content">
                            <div class="flex-col" style="width: max-content">
                                <span class="mat-body-strong">
                                    Lot {{ interest.lot.lotNumber }}
                                </span>
                                @if (interest.lot.marketStatus == marketStatusEnum.PreRelease) {
                                    <span class="mat-body-strong">
                                        Lot {{ interest.lot.lotNumber }} ({{
                                            MARKET_STATUS_ENUM[interest.lot.marketStatus]
                                        }})
                                    </span>
                                }
                                <div>
                                    <span class="mat-body-strong"
                                        >{{ interest.lot.projectName }},</span
                                    >
                                    <span class="mat-body-2"
                                        >&nbsp;{{ interest.lot.address.city }}</span
                                    >
                                </div>
                                @if (interest.lotIsNotAvailable && !interest.isQualified) {
                                    <span class="mat-body-2">
                                        {{ interest.lot.projectName }}&nbsp;-&nbsp;No longer
                                        Available
                                    </span>
                                }
                            </div>
                        </div>
                        <span class="flex"></span>
                        <button [matMenuTriggerFor]="menu" mat-icon-button>
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            @if (canSetLotInterestAsMain() && !interest.isPrimary) {
                                <button mat-menu-item (cbClick)="setPrimaryLot($event, interest)">
                                    <mat-icon>stars</mat-icon>
                                    &nbsp; Set as Primary
                                </button>
                            }
                            @if (
                                (isHouseAndLand || isDesignAndLand) &&
                                canRemoveLotInterest() &&
                                !interest.isPrimary
                            ) {
                                <button
                                    mat-menu-item
                                    (cbClick)="removeLotInterest($event, interest)"
                                >
                                    <mat-icon>remove_circle</mat-icon>
                                    &nbsp; Remove
                                </button>
                            }
                            <button mat-menu-item (cbClick)="viewLot($event, interest)">
                                <mat-icon>pageview</mat-icon>
                                &nbsp;View
                            </button>
                        </mat-menu>
                    </div>
                    @if (last) {
                        <div>
                            <mat-divider></mat-divider>
                        </div>
                    }
                </div>
            }
        }
    </mat-card-content>
    @if (canEdit && !mappedItem.isQualified()) {
        <div>
            <mat-divider class="card-divider"></mat-divider>
        </div>
    }
    @if (canEdit && !mappedItem.isQualified()) {
        <mat-card-actions class="end-center flex-row">
            @if (canAddLotInterest()) {
                <button mat-stroked-button color="accent" (cbClick)="openAddLotDialog($event)">
                    <mat-icon>add</mat-icon>
                    &nbsp;Add Lot Interest
                </button>
            }
        </mat-card-actions>
    }
</mat-card>
